import React, { useContext, useState } from 'react';
import { Button, Modal, Select } from 'antd';

import AmazonWebServicesContext from '@totem/components/administration/amazonWebServices/AmazonWebServicesContext';
import {
  AWS_INSTANCE_STATUS_OPTIONS,
  AwsInstanceStatus,
} from '@totem/components/administration/amazonWebServices/types';
import ModalFooter from '@totem/components/ui_components/dialogs/ModalFooter';
import ModalTitle from '@totem/components/ui_components/dialogs/ModalTitle';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { AWS_INSTANCES_ENDPOINT } from '@totem/utilities/endpoints';

const UpdateStatusModal = () => {
  const { getApiToken } = useContext(UserProfileContext);
  const { selectedInstance, activeAction, onActionClose, onRefresh } =
    useContext(AmazonWebServicesContext);
  const [status, setStatus] = useState<AwsInstanceStatus>(
    (selectedInstance?.status as AwsInstanceStatus) ?? 'Discovered',
  );
  const [saving, setSaving] = useState<boolean>(false);

  if (activeAction !== 'status' || !selectedInstance) {
    return null;
  }

  const handleSave = () => {
    setSaving(true);

    fetch(
      `${AWS_INSTANCES_ENDPOINT}/${selectedInstance.item.instance.instanceId}/status`,
      {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${getApiToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status }),
      },
    ).then(() => {
      setSaving(false);

      onActionClose();

      onRefresh();
    });
  };

  return (
    <Modal
      open
      title={<ModalTitle>Update Status</ModalTitle>}
      onCancel={onActionClose}
      footer={
        <ModalFooter>
          <Button onClick={onActionClose}>Cancel</Button>
          <Button type="primary" onClick={handleSave} loading={saving}>
            Save
          </Button>
        </ModalFooter>
      }
    >
      <p>
        Instance: <strong>{selectedInstance.name}</strong>
      </p>
      <Select
        style={{ width: '100%' }}
        value={status}
        onChange={setStatus}
        options={AWS_INSTANCE_STATUS_OPTIONS.map((option) => ({
          value: option,
          label: option,
        }))}
      />
    </Modal>
  );
};

export default UpdateStatusModal;
